import React from 'react';

import { EmployerWallet } from 'src/components/employer';

export const WalletAccountPageEmployerAdmin: React.FC = () => {
  return <EmployerWallet />;
};
